"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetInvoice200ResponseToJSON = exports.GetInvoice200ResponseFromJSONTyped = exports.GetInvoice200ResponseFromJSON = exports.instanceOfGetInvoice200Response = void 0;
const runtime_1 = require("../runtime");
const CreditNote_1 = require("./CreditNote");
const InvoiceApproval_1 = require("./InvoiceApproval");
const InvoiceCredit_1 = require("./InvoiceCredit");
const InvoiceCustomField_1 = require("./InvoiceCustomField");
const InvoiceFrequency_1 = require("./InvoiceFrequency");
const InvoiceHistoryItem_1 = require("./InvoiceHistoryItem");
const InvoiceItem_1 = require("./InvoiceItem");
const InvoiceKind_1 = require("./InvoiceKind");
const InvoiceMethod_1 = require("./InvoiceMethod");
const InvoiceStatus_1 = require("./InvoiceStatus");
const InvoiceStripe_1 = require("./InvoiceStripe");
const Refund_1 = require("./Refund");
const SmartActionTemplate_1 = require("./SmartActionTemplate");
/**
 * Check if a given object implements the GetInvoice200Response interface.
 */
function instanceOfGetInvoice200Response(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "payeeId" in value;
    isInstance = isInstance && "contactId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "stripe" in value;
    isInstance = isInstance && "invoice" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "isUBPInitialDeposit" in value;
    return isInstance;
}
exports.instanceOfGetInvoice200Response = instanceOfGetInvoice200Response;
function GetInvoice200ResponseFromJSON(json) {
    return GetInvoice200ResponseFromJSONTyped(json, false);
}
exports.GetInvoice200ResponseFromJSON = GetInvoice200ResponseFromJSON;
function GetInvoice200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'payeeId': json['payeeId'],
        'contactId': json['contactId'],
        'couponId': !(0, runtime_1.exists)(json, 'couponId') ? undefined : json['couponId'],
        'status': (0, InvoiceStatus_1.InvoiceStatusFromJSON)(json['status']),
        'dueDate': !(0, runtime_1.exists)(json, 'dueDate') ? undefined : (new Date(json['dueDate'])),
        'cutoffDate': !(0, runtime_1.exists)(json, 'cutoffDate') ? undefined : (new Date(json['cutoffDate'])),
        'dueAfterDays': !(0, runtime_1.exists)(json, 'dueAfterDays') ? undefined : json['dueAfterDays'],
        'currency': json['currency'],
        'amount': json['amount'],
        'tax': !(0, runtime_1.exists)(json, 'tax') ? undefined : json['tax'],
        'discount': !(0, runtime_1.exists)(json, 'discount') ? undefined : json['discount'],
        'total': json['total'],
        'recurring': !(0, runtime_1.exists)(json, 'recurring') ? undefined : (0, InvoiceFrequency_1.InvoiceFrequencyFromJSON)(json['recurring']),
        'subscriptionId': !(0, runtime_1.exists)(json, 'subscriptionId') ? undefined : json['subscriptionId'],
        'memo': !(0, runtime_1.exists)(json, 'memo') ? undefined : json['memo'],
        'footer': !(0, runtime_1.exists)(json, 'footer') ? undefined : json['footer'],
        'customFields': !(0, runtime_1.exists)(json, 'customFields') ? undefined : (json['customFields'].map(InvoiceCustomField_1.InvoiceCustomFieldFromJSON)),
        'items': !(0, runtime_1.exists)(json, 'items') ? undefined : (json['items'].map(InvoiceItem_1.InvoiceItemFromJSON)),
        'stripe': (0, InvoiceStripe_1.InvoiceStripeFromJSON)(json['stripe']),
        'invoice': json['invoice'],
        'subscription': !(0, runtime_1.exists)(json, 'subscription') ? undefined : json['subscription'],
        'scheduledSmartActions': !(0, runtime_1.exists)(json, 'scheduledSmartActions') ? undefined : json['scheduledSmartActions'],
        'sendAt': !(0, runtime_1.exists)(json, 'sendAt') ? undefined : (new Date(json['sendAt'])),
        'smartActionTemplates': !(0, runtime_1.exists)(json, 'smartActionTemplates') ? undefined : (json['smartActionTemplates'].map(SmartActionTemplate_1.SmartActionTemplateFromJSON)),
        'isUpcomingInvoice': !(0, runtime_1.exists)(json, 'isUpcomingInvoice') ? undefined : json['isUpcomingInvoice'],
        'wasScheduled': !(0, runtime_1.exists)(json, 'wasScheduled') ? undefined : json['wasScheduled'],
        'paymentMethod': !(0, runtime_1.exists)(json, 'paymentMethod') ? undefined : json['paymentMethod'],
        'paidAt': !(0, runtime_1.exists)(json, 'paidAt') ? undefined : (new Date(json['paidAt'])),
        'productId': !(0, runtime_1.exists)(json, 'productId') ? undefined : json['productId'],
        'approval': !(0, runtime_1.exists)(json, 'approval') ? undefined : (0, InvoiceApproval_1.InvoiceApprovalFromJSON)(json['approval']),
        'paymentIntentId': !(0, runtime_1.exists)(json, 'paymentIntentId') ? undefined : json['paymentIntentId'],
        'invoiceMethod': !(0, runtime_1.exists)(json, 'invoiceMethod') ? undefined : (0, InvoiceMethod_1.InvoiceMethodFromJSON)(json['invoiceMethod']),
        'packageInstanceId': !(0, runtime_1.exists)(json, 'packageInstanceId') ? undefined : json['packageInstanceId'],
        'pendingTransactions': !(0, runtime_1.exists)(json, 'pendingTransactions') ? undefined : json['pendingTransactions'],
        'memberId': !(0, runtime_1.exists)(json, 'memberId') ? undefined : json['memberId'],
        'kind': !(0, runtime_1.exists)(json, 'kind') ? undefined : (0, InvoiceKind_1.InvoiceKindFromJSON)(json['kind']),
        'credits': !(0, runtime_1.exists)(json, 'credits') ? undefined : (json['credits'].map(InvoiceCredit_1.InvoiceCreditFromJSON)),
        'minimumAmount': !(0, runtime_1.exists)(json, 'minimumAmount') ? undefined : json['minimumAmount'],
        'paymentNeedsAttention': !(0, runtime_1.exists)(json, 'paymentNeedsAttention') ? undefined : json['paymentNeedsAttention'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'refunds': !(0, runtime_1.exists)(json, 'refunds') ? undefined : (json['refunds'].map(Refund_1.RefundFromJSON)),
        'creditNotes': !(0, runtime_1.exists)(json, 'creditNotes') ? undefined : (json['creditNotes'].map(CreditNote_1.CreditNoteFromJSON)),
        'isUBPInitialDeposit': json['isUBPInitialDeposit'],
        'depositBalance': !(0, runtime_1.exists)(json, 'depositBalance') ? undefined : json['depositBalance'],
        'history': !(0, runtime_1.exists)(json, 'history') ? undefined : (json['history'].map(InvoiceHistoryItem_1.InvoiceHistoryItemFromJSON)),
    };
}
exports.GetInvoice200ResponseFromJSONTyped = GetInvoice200ResponseFromJSONTyped;
function GetInvoice200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'payeeId': value.payeeId,
        'contactId': value.contactId,
        'couponId': value.couponId,
        'status': (0, InvoiceStatus_1.InvoiceStatusToJSON)(value.status),
        'dueDate': value.dueDate === undefined ? undefined : (value.dueDate.toISOString().substr(0, 10)),
        'cutoffDate': value.cutoffDate === undefined ? undefined : (value.cutoffDate.toISOString().substr(0, 10)),
        'dueAfterDays': value.dueAfterDays,
        'currency': value.currency,
        'amount': value.amount,
        'tax': value.tax,
        'discount': value.discount,
        'total': value.total,
        'recurring': (0, InvoiceFrequency_1.InvoiceFrequencyToJSON)(value.recurring),
        'subscriptionId': value.subscriptionId,
        'memo': value.memo,
        'footer': value.footer,
        'customFields': value.customFields === undefined ? undefined : (value.customFields.map(InvoiceCustomField_1.InvoiceCustomFieldToJSON)),
        'items': value.items === undefined ? undefined : (value.items.map(InvoiceItem_1.InvoiceItemToJSON)),
        'stripe': (0, InvoiceStripe_1.InvoiceStripeToJSON)(value.stripe),
        'invoice': value.invoice,
        'subscription': value.subscription,
        'scheduledSmartActions': value.scheduledSmartActions,
        'sendAt': value.sendAt === undefined ? undefined : (value.sendAt.toISOString().substr(0, 10)),
        'smartActionTemplates': value.smartActionTemplates === undefined ? undefined : (value.smartActionTemplates.map(SmartActionTemplate_1.SmartActionTemplateToJSON)),
        'isUpcomingInvoice': value.isUpcomingInvoice,
        'wasScheduled': value.wasScheduled,
        'paymentMethod': value.paymentMethod,
        'paidAt': value.paidAt === undefined ? undefined : (value.paidAt.toISOString().substr(0, 10)),
        'productId': value.productId,
        'approval': (0, InvoiceApproval_1.InvoiceApprovalToJSON)(value.approval),
        'paymentIntentId': value.paymentIntentId,
        'invoiceMethod': (0, InvoiceMethod_1.InvoiceMethodToJSON)(value.invoiceMethod),
        'packageInstanceId': value.packageInstanceId,
        'pendingTransactions': value.pendingTransactions,
        'memberId': value.memberId,
        'kind': (0, InvoiceKind_1.InvoiceKindToJSON)(value.kind),
        'credits': value.credits === undefined ? undefined : (value.credits.map(InvoiceCredit_1.InvoiceCreditToJSON)),
        'minimumAmount': value.minimumAmount,
        'paymentNeedsAttention': value.paymentNeedsAttention,
        'updatedAt': (value.updatedAt.toISOString().substr(0, 10)),
        'refunds': value.refunds === undefined ? undefined : (value.refunds.map(Refund_1.RefundToJSON)),
        'creditNotes': value.creditNotes === undefined ? undefined : (value.creditNotes.map(CreditNote_1.CreditNoteToJSON)),
        'isUBPInitialDeposit': value.isUBPInitialDeposit,
        'depositBalance': value.depositBalance,
        'history': value.history === undefined ? undefined : (value.history.map(InvoiceHistoryItem_1.InvoiceHistoryItemToJSON)),
    };
}
exports.GetInvoice200ResponseToJSON = GetInvoice200ResponseToJSON;
//# sourceMappingURL=GetInvoice200Response.js.map